import { xcss } from '@atlaskit/primitives';

export const paymentTypeStyles = xcss({
  borderRightStyle: 'solid',
  borderRightWidth: 'border.width',
  borderRightColor: 'color.border',
});
